export default "__VITE_ASSET__DYC$W0i___"